export const PLAN_NO = {
  DEVELOPMENT_STORE: 'development_store',
  DEVELOPMENT: 'development',
  DEVELOPMENT2022: 'development2022',
  TRIAL: 'trial',
  TRIAL2022: 'trial2022',
  STARTER: 'starter',
  PROFESSIONAL: 'professional',
  ADVANCED: 'advanced',
  BUILD: 'build',
  OPTIMIZE: 'optimize',
  ENTERPRISE: 'enterprise',
}

export const PLAN_TYPE = {
  ANNUALLY: 'annually',
  MONTHLY: 'monthly',
}

export const PLAN_ACTION = {
  UPGRADE: 'upgrade',
  DOWNGRADE: 'downgrade',
  CURRENT: 'current',
  SWITCH_YEARLY: 'switch_yearly',
  SWITCH_MONTHLY: 'switch_monthly',
}

export const PLAN_NAMES = {
  trial: 'Free',
  starter: 'Starter',
  professional: 'Build',
  advanced: 'Optimize',
  build: 'Build',
  optimize: 'Optimize',
  enterprise: 'Enterprise',
  trial2022: 'Free',
};

export const PLAN_SHOPIFY = {
  AFFILIATE: 'affiliate',
  PARTNER_TEST: 'partner_test',
};

export const PLAN_PRICING_DEFAULT = {
  starter: 15,
  development: 0,
  trial: 0
};
